import { CloudAnalyticsModel, type CloudAnalyticsModelMetricModel, Roles } from "@doitintl/cmp-models";
import { getCollection, modelServerTimestamp, type ModelTimestamp } from "@doitintl/models-any";

import { type CustomerRef } from "../../../types";

export const metricsCollectionRef = () =>
  getCollection(CloudAnalyticsModel).doc("metrics").collection("cloudAnalyticsMetrics");

export const saveMetricData = async (
  metricData: CloudAnalyticsModelMetricModel,
  metricId?: string
): Promise<string> => {
  const docRef = metricId ? metricsCollectionRef().doc(metricId) : metricsCollectionRef().newDoc();
  await docRef.set(metricData);
  return docRef.id;
};

export const copyMetric = async (
  customerRef: CustomerRef,
  userEmail: string,
  metricData: CloudAnalyticsModelMetricModel
) => {
  const updatedCollaborators = metricData.collaborators.map((collaborator) =>
    collaborator.role === Roles.OWNER ? { ...collaborator, email: userEmail } : collaborator
  );
  const newMetricData = {
    ...metricData,
    customer: customerRef,
    name: `Copy of ${metricData.name}`,
    collaborators: updatedCollaborators,
    public: Roles.VIEWER,
    timeCreated: modelServerTimestamp() as ModelTimestamp,
    timeModified: modelServerTimestamp() as ModelTimestamp,
    type: "custom",
  };
  delete newMetricData.owner;
  return saveMetricData(newMetricData);
};
